import Vue from 'vue'
import Router from 'vue-router';

import AppHome from './components/AppHome.vue';
import BubbleChartAesthetics from './components/BubbleChartAesthetics'
import BubbleChartBlended from './components/BubbleChartBlended'
import BubbleChartMethod from './components/BubbleChartMethod'
import BubbleChartPragmatics from './components/BubbleChartPragmatics'
import BarChart from "./components/BarChart";
import TimelineChart from "./components/TimelineChart";
import SankeyChart from "./components/SankeyChart";
import BarMultiples from "./components/BarMultiples";
import LineMultiples from "./components/LineMultiples";
import PieChart from "./components/PieChart"

Vue.use(Router);

export const router = new Router({

  mode: 'history',
  routes: [
    {
      path: '/',
        component: AppHome,
    },
    {
      path: '/bubblechart/pragmatics',
      component: BubbleChartPragmatics
    },
    {
      path: '/bubblechart/method',
      component: BubbleChartMethod
    },
    {
      path: '/bubblechart/aesthetics',
      component: BubbleChartAesthetics
    },
    {
      path: '/bubblechart/blended',
      component: BubbleChartBlended
    },
    {
      path: '/barchart',
      component: BarChart
    },
    {
      path: '/timelinechart',
      component: TimelineChart
    },
    {
      path: '/sankeychart',
      component: SankeyChart
    },
    {
      path: '/linemultiples',
      component: LineMultiples
    },
    {
      path: '/barmultiples',
      component: BarMultiples
    },
    {
      path: '/piechart',
      component: PieChart
    }
  ]
})

